module.exports = __webpack_public_path__ + "static/media/stormtrooper.dba3bf48.jpg";